// Global safety net: log classList runtime errors for debugging
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("classList")) {
    // Log error details for tracing
    console.error("classList error detected:", e.message, e.filename, e.lineno, e.colno, e.error);
    if (e.error && e.error.stack) {
      console.error("Stack trace:", e.error.stack);
    }
    // Optionally stop propagation to prevent crash
    e.stopImmediatePropagation();
  }
});

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// Import Tailwind CSS
import "./index.css";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);